import { c as _c } from "react/compiler-runtime";
import { formatCurrency, getPlaneImage } from "@/libs/utils";
import { DestinationPriceRowGrid, DestinationRowDestination, DestinationRowPrice, PlaneDiv, StyledDestinationFromPriceSlide, StyledH1, StyledH2 } from "@/styles/destination-from-price-slide";
import Image from "next/image";
const TDestinationFromPriceRow = t0 => {
  const $ = _c(46);
  const {
    orientation,
    row,
    position
  } = t0;
  const t1 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t2;
  if ($[0] !== orientation || $[1] !== row.destination_color || $[2] !== row.location || $[3] !== t1) {
    t2 = <DestinationRowDestination $color={row.destination_color} $shade={t1} $orientation={orientation}>{row.location}</DestinationRowDestination>;
    $[0] = orientation;
    $[1] = row.destination_color;
    $[2] = row.location;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "0.1rem"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== row.departure_location_id?.length || $[7] !== row.plane_color || $[8] !== row.show_board) {
    t4 = !row.show_board && (row.departure_location_id?.length ?? 0) > 0 && <PlaneDiv><Image src={`/${getPlaneImage(row.plane_color)}`} alt="plane" fill={true} /></PlaneDiv>;
    $[6] = row.departure_location_id?.length;
    $[7] = row.plane_color;
    $[8] = row.show_board;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      textAlign: "right"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t7;
  if ($[11] !== row.board_id?.label || $[12] !== row.departure_location_id || $[13] !== row.show_board) {
    t7 = !row.show_board && (row.departure_location_id?.length ?? 0) > 0 ? row.departure_location_id.map(_temp).join(", ") : row.board_id?.label ?? "";
    $[11] = row.board_id?.label;
    $[12] = row.departure_location_id;
    $[13] = row.show_board;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== orientation || $[16] !== row.destination_color || $[17] !== t6 || $[18] !== t7) {
    t8 = <DestinationRowDestination $orientation={orientation} style={t5} $color={row.destination_color} $shade={t6}>{t7}</DestinationRowDestination>;
    $[15] = orientation;
    $[16] = row.destination_color;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t8) {
    t9 = <div style={t3}>{t4}{t8}</div>;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      fontWeight: "bold"
    };
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = row.destination_color;
  const t12 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t13;
  if ($[24] !== row.category) {
    t13 = "*".repeat(row.category);
    $[24] = row.category;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== orientation || $[27] !== row.destination_color || $[28] !== row.tour_id.label || $[29] !== t12 || $[30] !== t13) {
    t14 = <DestinationRowDestination $orientation={orientation} style={t10} $color={t11} $shade={t12}>{t13} {row.tour_id.label}</DestinationRowDestination>;
    $[26] = orientation;
    $[27] = row.destination_color;
    $[28] = row.tour_id.label;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = row.price_color;
  const t16 = row.has_shade_price ? row.shade_color_price : undefined;
  let t17;
  if ($[32] !== row.price) {
    t17 = formatCurrency(row.price);
    $[32] = row.price;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== orientation || $[35] !== row.price_color || $[36] !== t16 || $[37] !== t17) {
    t18 = <DestinationRowPrice $orientation={orientation} $color={t15} $shade={t16}>od {t17}</DestinationRowPrice>;
    $[34] = orientation;
    $[35] = row.price_color;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== orientation || $[40] !== position || $[41] !== t14 || $[42] !== t18 || $[43] !== t2 || $[44] !== t9) {
    t19 = <DestinationPriceRowGrid $orientation={orientation} $position={position}>{t2}{t9}{t14}{t18}</DestinationPriceRowGrid>;
    $[39] = orientation;
    $[40] = position;
    $[41] = t14;
    $[42] = t18;
    $[43] = t2;
    $[44] = t9;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};
const DestinationFromPriceSlide = t0 => {
  const $ = _c(29);
  const {
    slide
  } = t0;
  const t1 = slide.orientation;
  const t2 = slide.attributes.position?.value ?? "left";
  const t3 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <Image fill={true} alt="" src={t3} priority={true} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = slide.attributes.has_shade_title_1 ? slide.attributes.shade_color_title_1 : undefined;
  let t6;
  if ($[2] !== slide.attributes.color_title_1 || $[3] !== slide.attributes.title_1 || $[4] !== slide.orientation || $[5] !== t5) {
    t6 = <StyledH1 $orientation={slide.orientation} $color={slide.attributes.color_title_1} $shade={t5}>{slide.attributes.title_1}</StyledH1>;
    $[2] = slide.attributes.color_title_1;
    $[3] = slide.attributes.title_1;
    $[4] = slide.orientation;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = slide.attributes.has_shade_title_2 ? slide.attributes.shade_color_title_2 : undefined;
  const t8 = slide.attributes.position?.value ?? "left";
  let t9;
  if ($[7] !== slide.attributes.color_title_2 || $[8] !== slide.attributes.title_2 || $[9] !== slide.orientation || $[10] !== t7 || $[11] !== t8) {
    t9 = <StyledH2 $orientation={slide.orientation} $color={slide.attributes.color_title_2} $shade={t7} $position={t8}>{slide.attributes.title_2}</StyledH2>;
    $[7] = slide.attributes.color_title_2;
    $[8] = slide.attributes.title_2;
    $[9] = slide.orientation;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== slide.attributes.position?.value || $[14] !== slide.attributes.rows || $[15] !== slide.orientation) {
    let t11;
    if ($[17] !== slide.attributes.position?.value || $[18] !== slide.orientation) {
      t11 = (row, index) => <TDestinationFromPriceRow orientation={slide.orientation} position={slide.attributes.position?.value ?? "left"} key={index} row={row} />;
      $[17] = slide.attributes.position?.value;
      $[18] = slide.orientation;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    t10 = slide.attributes.rows.map(t11);
    $[13] = slide.attributes.position?.value;
    $[14] = slide.attributes.rows;
    $[15] = slide.orientation;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6 || $[22] !== t9) {
    t11 = <div>{t6}{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== slide.orientation || $[25] !== t11 || $[26] !== t2 || $[27] !== t4) {
    t12 = <StyledDestinationFromPriceSlide $orientation={t1} $position={t2}>{t4}{t11}</StyledDestinationFromPriceSlide>;
    $[24] = slide.orientation;
    $[25] = t11;
    $[26] = t2;
    $[27] = t4;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default DestinationFromPriceSlide;
function _temp(loc) {
  return loc.label;
}